<div class="w-100 float-left">
    <div class="w-100 float-left v-align relative b-b">
        <h5 class="medium float-left">Cache Settings</h5>
        <div style="flex-grow: 1;"></div>
        <button class="btn btn-secondary float-right mb-2"> {{'back' | translate}}
        </button>
    </div>

    <div class="w-100 float-left mt-3">
        <div class="btn btn-link">Clear Cache</div>
    </div>
    <div class="w-100 float-left mt-3">
        <div class="btn btn-link">Clear Memory</div>
    </div>
    <div class="w-100 float-left mt-3">
        <div class="btn btn-link">Clear Dump</div>
    </div>
</div>



// WEBPACK FOOTER //
// ./src/app/tools/clearComponent/clearComponent.html